import Logger from '../util/Logger';
import _ from 'lodash';

export default {

  /**
   * Get the id
   * @param media
   * @returns {string} Media id
   */
  getId (media) {
    if (!media) {
      Logger.assert('Must pass an media object');
    } else {
      const id = _.get(media, 'id');
      if (!id) {
        Logger.assert('Media was missing id');
      } else {
        return id;
      }
    }
  },

  getPhotoUrl (media, width = undefined, height = undefined) {
    if (!media) {
      Logger.assert('Must pass an media object');
    } else {
      let url = _.get(media, 'photo') || '';
      if (!!url) {
        if (!!width && !!height) {
          url = `${url}?w=${width}&h=${height}`;
        } else {
          if (!!width) {
            url = `${url}?w=${width}`;
          } else if (!!height) {
            url = `${url}?h=${height}`;
          }
        }

        return url;
      } else {
        return '';
      }
    }
  },

  getPdfUrl (media) {
    if (!media) {
      Logger.assert('Must pass an media object');
    } else {
      return _.get(media, 'pdf') || '';
    }
  },

  getThumbnailUrl (media) {
    if (!media) {
      Logger.assert('Must pass an media object');
    } else {
      return _.get(media, 'thumb') || '';
    }
  },

  getVideoUrl (media) {
    if (!media) {
      Logger.assert('Must pass an media object');
    } else {
      return _.get(media, 'video_mp4') || '';
    }
  }

};
